import React from 'react';
import { Stack, Grid, IconButton } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';
import MaterialBox from '../../../../components/MaterialBox';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import './ReportTable.css';

const DefectSummary = ({ formData, handleChange, handleDefectRowChange, addDefectRow, removeDefectRow }) => {
    return (
        <Stack spacing={4}>
            <MaterialBox>
                <MaterialTypography variant="h6" fontWeight="bold" mb={2}>
                    Bug Statistics & Analysis
                </MaterialTypography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Stack spacing={1}>
                            <MaterialTypography variant="caption" fontWeight="bold">Total Defects Logged</MaterialTypography>
                            <MaterialInput size="small" name="totalDefects" value={formData.totalDefects} onChange={handleChange} placeholder="0" fullWidth />
                        </Stack>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Stack spacing={1}>
                            <MaterialTypography variant="caption" fontWeight="bold">Reopened Defects</MaterialTypography>
                            <MaterialInput size="small" name="reopenedDefects" value={formData.reopenedDefects} onChange={handleChange} placeholder="0" fullWidth />
                        </Stack>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Stack spacing={1}>
                            <MaterialTypography variant="caption" fontWeight="bold">Repetitive Defects</MaterialTypography>
                            <MaterialInput size="small" name="repetitiveDefects" value={formData.repetitiveDefects} onChange={handleChange} placeholder="0" fullWidth />
                        </Stack>
                    </Grid>
                </Grid>
            </MaterialBox>

            <MaterialBox>
                <MaterialTypography variant="h6" fontWeight="bold" mb={2}>
                    Defect Table
                </MaterialTypography>
                <div className="report-table-container">
                    <table className="report-table">
                        <thead>
                            <tr>
                                <th>Severity</th>
                                <th>Count</th>
                                <th>Status</th>
                                <th style={{ width: '50px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formData.defects.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                        <MaterialInput
                                            size="small"
                                            value={row.severity}
                                            placeholder="Severity"
                                            onChange={(e) => handleDefectRowChange(index, 'severity', e.target.value)}
                                            fullWidth
                                        />
                                    </td>
                                    <td>
                                        <MaterialInput
                                            size="small"
                                            value={row.count}
                                            placeholder="Count"
                                            onChange={(e) => handleDefectRowChange(index, 'count', e.target.value)}
                                            fullWidth
                                        />
                                    </td>
                                    <td>
                                        <MaterialInput
                                            size="small"
                                            value={row.status}
                                            placeholder="Status"
                                            onChange={(e) => handleDefectRowChange(index, 'status', e.target.value)}
                                            fullWidth
                                        />
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <Stack direction="row" spacing={1} justifyContent="center">
                                            {index === formData.defects.length - 1 && (
                                                <IconButton color="success" onClick={addDefectRow}>
                                                    <AddCircleIcon />
                                                </IconButton>
                                            )}
                                            {formData.defects.length > 1 && (
                                                <IconButton color="error" onClick={() => removeDefectRow(index)}>
                                                    <RemoveCircleIcon />
                                                </IconButton>
                                            )}
                                        </Stack>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </MaterialBox>
        </Stack>
    );
};

export default DefectSummary;
